import { LogoType } from '@wix/shoutout-email-model-v3';
export const NEW_LOGO_IMAGE_SIZES = {
    small: 60,
    medium: 90,
    large: 122,
};
export const WIX_BRAND_LOGO_URLS = {
    [LogoType.wixClassic]: '82f27b_51c1e39598f94531ab9d830494fe17df~mv2.png',
    [LogoType.wixStudio]: '82f27b_af1457d5816a4550a50283a8c5601232~mv2.png',
    [LogoType.wixPayments]: 'b02258_e40cf8b05f1c4538b396236067ea03fc~mv2.png',
    [LogoType.wixVibe]: 'b02258_e1bf6daf6c3e4047a3cf9c28ff8c168c~mv2.png',
    [LogoType.marketplace]: 'd2f3f5_42e3a2b34fbf414c88efc9470fccc78f~mv2.png',
    [LogoType.rise]: 'b02258_02ccd3d0275e4a6ea6557b4a6d4c1387~mv2.png',
};
const classicLogoStyle = {
    backgroundColorEnabled: false,
    imageSize: 'small',
    textAlign: 'left',
    region: { paddingTop: '10px' },
};
export const WIX_BRAND_LOGO_STYLES = {
    [LogoType.wixClassic]: classicLogoStyle,
    [LogoType.wixStudio]: {
        backgroundColorEnabled: false,
        imageSize: 'small',
        textAlign: 'left',
        region: { paddingTop: '40px' },
    },
    [LogoType.wixPayments]: classicLogoStyle,
    [LogoType.wixVibe]: {
        backgroundColorEnabled: true,
        backgroundColor: '#EEF0FF',
        backgroundSize: 'box',
        imageSize: 'small',
        textAlign: 'center',
        region: {
            paddingTop: '60px',
            paddingBottom: '25px',
        },
    },
    [LogoType.marketplace]: {
        backgroundColorEnabled: false,
        imageSize: 'small',
        textAlign: 'left',
        region: {},
    },
    [LogoType.rise]: classicLogoStyle,
};
export const WIX_BRAND_LOGO_TYPES = [
    LogoType.wixClassic,
    LogoType.wixStudio,
    LogoType.wixPayments,
    LogoType.wixVibe,
    LogoType.marketplace,
    LogoType.rise,
];
//# sourceMappingURL=logo-constants.js.map